<div class="row" *ngIf="!loading">
  <div class="col-lg-7">
    <div class="container-fluid risk-overview-scores">
      <div class="row publisher-scores hidden-md-down" *ngIf="hasPublisherScores">
        <div class="col-lg-12">
          <h3 class="sub-title">
            Publisher Scores
          </h3>
        </div>
        <div class="col-4 publisher-score" *ngIf="data?.ranking?.final?.score">
          <div class="label">Final Score</div>
          <div class="value big-number" enAnonLock>{{data?.ranking?.final?.score}}({{data?.ranking?.final?.grade}})
          </div>
        </div>
        <div class="col-4 publisher-score" *ngIf="data?.ranking?.popularity?.score">
          <div class="label">Popularity Score</div>
          <div class="value big-number" enAnonLock>
            {{data?.ranking?.popularity?.score}}({{data?.ranking?.popularity?.grade}})</div>
        </div>
        <div class="col-4 publisher-score" *ngIf="data?.ranking?.ivt?.score">
          <div class="label">IVT Score</div>
          <div class="value big-number" enAnonLock>{{data?.ranking?.ivt?.score}}({{data?.ranking?.ivt?.grade}})</div>
        </div>
        <div class="col-4 publisher-score" *ngIf="data?.ranking?.brandSafety?.score">
          <div class="label">Brand Safety Score</div>
          <div class="value big-number" enAnonLock>
            {{data?.ranking?.brandSafety?.score}}({{data?.ranking?.brandSafety?.grade}})
          </div>
        </div>
        <div class="col-4 publisher-score" *ngIf="data?.ranking?.adsTxt?.score">
          <div class="label">App-ads.txt Score</div>
          <div class="value big-number" enAnonLock>{{data?.ranking?.adsTxt?.score}}({{data?.ranking?.adsTxt?.grade}})
          </div>
        </div>
        <div class="col-4 publisher-score" *ngIf="data?.ranking?.viewability?.score">
          <div class="label">Viewability Score</div>
          <div class="value big-number" enAnonLock>
            {{data?.ranking?.viewability?.score}}({{data?.ranking?.viewability?.grade}})
          </div>
        </div>
        <div class="col-4 publisher-score" *ngIf="data?.ranking?.permissions?.score">
          <div class="label">Permission Score</div>
          <div class="value big-number" enAnonLock>
            {{data?.ranking?.permissions?.score}}({{data?.ranking?.permissions?.grade}})
          </div>
        </div>
        <div class="col-4 publisher-score" *ngIf="data?.ranking?.adDensity?.score">
          <div class="label">Ad Density</div>
          <div class="value big-number" enAnonLock>
            {{data?.ranking?.adDensity?.score}}({{data?.ranking?.adDensity?.grade}})</div>
        </div>
        <div class="col-4 publisher-score" *ngIf="data?.ranking?.dauMau?.score">
          <div class="label">DAU / MAU</div>
          <div class="value big-number" enAnonLock>{{data?.ranking?.dauMau?.score}}({{data?.ranking?.dauMau?.grade}})
          </div>
        </div>
        <div class="col-4 publisher-score" *ngIf="data?.ranking?.userEngagement?.score">
          <div class="label">Engagement Score</div>
          <div class="value big-number" enAnonLock>
            {{data?.ranking?.userEngagement?.score}}({{data?.ranking?.userEngagement?.grade}})</div>
        </div>
      </div>
      <div class="row risk-devices" *ngIf="!isFreemium">
        <div class="col-xl-6 risk-device">
          <h3 class="sub-title mt-4">
            Risk Score
            <a class="btn btn-link help-icon p-0" data-placement="top" data-toggle="tooltip" enTooltip
              data-animation="false" title="Pixalate's unique overall advertising risk score based on blended risk factors including
               brand safety, invalid traffic and ad inventory.">
              <img src="/assets/images/icon-indicator-info-2.svg" alt="Info Icon" />
            </a>
          </h3>
          <ng-container *ngIf="byRegions && byRegions?.length > 0">
            <div class="row risk-ratings" *ngFor="let riskScore of byRegions">
              <div class="col-lg-4 pr-0">
                <div class="text-container">
                  <div class="text-item">
                    {{riskScore.countryCode === 'NA' ? 'North America':riskScore.countryCode}}
                  </div>
                </div>
              </div>
              <div class="col">
                <risk-heat-bar [risk]='riskScore.pixalateRating' [tooltip]='riskScore?.pixalateScoreReasonCodeHTML'>
                </risk-heat-bar>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="risk-totals-cont pl-0">
        <div class="row risk-totals">
          <div class="col risk-total-item">
            <div class="divider" *ngIf="hasPublisherScores || hasReputation"></div>
            <h3 class="sub-title">
              IVT
              <a class="btn btn-link help-icon p-0" data-placement="top" data-toggle="tooltip" enTooltip
                data-animation="false" title="The overall percentage of Invalid Traffic (IVT) associated with advertising transactions for the
                 app.  All IVT calculations are derived from standardized definitions of invalid traffic maintained by
                 the Media Rating Council, Inc. (MRC), Interactive Advertising Bureau (IAB), and Trustworthy
                 Accountability Group (TAG).">
                <img src="/assets/images/icon-indicator-info-2.svg" alt="Info Icon" />
              </a>
            </h3>
            <div class="big-number">
              <ng-container *ngIf="isFollowing || !isFreemium">
                <a class="btn btn-link p-0 big-number mr-2" (click)="goToSection('#app-ivt')">
                  {{data?.riskOverview?.ivt | perc:'1.2-2'}}
                </a>
                <risk-heat-meter *ngIf='data?.riskOverview?.ivtRisk !== "N/A" && !isFreemium'
                  [risk]='data?.riskOverview?.ivtRisk'></risk-heat-meter>
              </ng-container>
              <ng-container *ngIf="!isFollowing && isFreemium">
                <div class="freemium-lock">
                  <i class="fa fa-lock"></i>
                </div>
              </ng-container>
            </div>
          </div>
          <div class="col risk-total-item">
            <div class="divider" *ngIf="hasPublisherScores || hasReputation"></div>
            <h3 class="sub-title">
              Est. SSAI
              <a class="btn btn-link help-icon p-0" data-placement="top" data-toggle="tooltip" enTooltip
                data-animation="false" title="The percentage of traffic observed to utilize server-side-ad-insertion (SSAI) integrations for
                 ad/ad content delivery to the end user.">
                <img src="/assets/images/icon-indicator-info-2.svg" alt="Info Icon" />
              </a>
            </h3>
            <div class="big-number" enAnonLock>
              {{data?.riskOverview?.nonGivtSivtSsaiImpressionsRate | perc:'1.2-2'}}
            </div>
          </div>
          <div class="w-100"></div>
          <div class="col risk-total-item">
            <div class="divider" *ngIf="hasPublisherScores || hasReputation"></div>
            <h3 class="sub-title">
              Est. Transparent SSAI
              <a class="btn btn-link help-icon p-0" data-placement="top" data-toggle="tooltip" enTooltip
                data-animation="false" title="SSAI tracked impressions that come from proxies passing X-Device-User-Agent headers for more
                   transparency.">
                <img src="/assets/images/icon-indicator-info-2.svg" alt="Info Icon" />
              </a>
            </h3>
            <div class="big-number" enAnonLock>
              {{data?.riskOverview?.nonGivtSivtSsaiTransparentImpressionsRate | perc:'1.2-2'}}
            </div>
          </div>
          <div class="col risk-total-item">
            <div class="divider" *ngIf="hasPublisherScores || hasReputation"></div>
            <h3 class="sub-title">
              Brand Safety Risk
              <a class="btn btn-link help-icon p-0" data-placement="top" data-toggle="tooltip" enTooltip
                data-animation="false" title="Risk factors to advertiser Brand Safety broken down by both in-app content such as images, and
                 descriptive text about the app.">
                <img src="/assets/images/icon-indicator-info-2.svg" alt="Info Icon" />
              </a>
            </h3>
            <div class="d-flex brand-safety">
              <div class="label">
                <a class="btn btn-link p-0" (click)="goToSection('#brand-safety-risk-description')">Description</a>
              </div>
              <div>
                <risk-heat-meter [risk]='data?.riskOverview?.brandSafetyDescriptionRisk' enAnonLock></risk-heat-meter>
              </div>
            </div>
            <div class="d-flex brand-safety">
              <div class="label">
                <a class="btn btn-link p-0" (click)="goToSection('#brand-safety-risk-content')">Content</a>
              </div>
              <div>
                <risk-heat-meter [risk]='data?.riskOverview?.brandSafetyContentRisk' enAnonLock></risk-heat-meter>
              </div>
            </div>
          </div>
        </div>
      </div>
      <app-follow-unlock label="Invalid Traffic" (followClick)="follow()" *ngIf="!isFollowing && isFreemium">
      </app-follow-unlock>
    </div>
  </div>
  <div class="col-lg-5 px-advisories">
    <div class="container-fluid info-column pix-advisories" [ngClass]="{ freemium: isFreemium }">
      <div class='info-section'>
        <h5 class='info-title'>
          <span>Pixalate Advisories</span>
          <info-tooltip title="Pixalate's unique listing of key advisories for a particular app based on risk factors
            (e.g., app-ads.txt, app permissions, privacy terms, etc.)."></info-tooltip>
        </h5>
        <div class='info-list-2'>
          <info-list-item label='App-ads.txt Detected'
            [suggestionConfig]='{ type: "ctv", id: data?.overview?.appId, metricId: "riskOverview.hasAdsTxt" }'
            [value]='data?.riskOverview?.hasAdsTxt | yesno:"capitalize"'
            (valueInteract)="_userService.ottDiscoveryEnabled() ? goToDiscoveryClick({param: 'isAdsTxtEnabled', paramValue: data?.riskOverview?.hasAdsTxt ? 'T' : 'F'}) : null"
            valueIcon='/assets/images/icon-indicator-{{data?.riskOverview?.hasAdsTxt | yesno}}-2.svg'>
          </info-list-item>

          <info-list-item label='Exists in the App Store'>

            <ng-container #value>
              <ng-container *ngIf="data?.riskOverview?.isExistInAppStore !== 'N/A'">
                <img src="/assets/images/icon-indicator-{{data?.riskOverview?.isExistInAppStore | yesno}}-2.svg"
                  alt="Info Icon" />
              </ng-container>
              <ng-container *ngIf="data?.riskOverview?.isExistInAppStore === 'N/A'">
                <i class="fa fa-times-circle"></i>
              </ng-container>
              <span>{{data?.riskOverview?.isExistInAppStore | yesno:"capitalize"}}</span>
              <span
                *ngIf="!data?.appOverview?.isExistInAppStore && data?.appInfo?.appRemovedDate && data?.appInfo?.appRemovedDate !== 'N/A'">-
                Removed as of {{data?.appInfo?.appRemovedDate | date}}</span>
            </ng-container>
          </info-list-item>

          <info-list-item label='WHOIS Info Hidden'>
            <ng-container #value>
              <ng-container
                *ngIf="_userService.ottDiscoveryEnabled() && data?.riskOverview?.isPrivateDomain !== 'N/A'; else privatedomain">
                <a class="btn btn-link p-0"
                  (click)="goToDiscoveryClick({param: 'isPrivateDomain', paramValue: data?.riskOverview?.isPrivateDomain ? 'T' : 'F'})">
                  <img src="/assets/images/icon-indicator-{{data?.riskOverview?.isPrivateDomain | yesno:'rev'}}-2.svg"
                    alt="Info Icon" />
                  {{data?.riskOverview?.isPrivateDomain | yesno:"capitalize"}}
                </a>
              </ng-container>
              <ng-template #privatedomain>
                {{data?.riskOverview?.isPrivateDomain | yesno:"capitalize"}}
              </ng-template>
            </ng-container>
          </info-list-item>

          <info-list-item *ngIf="data?.riskOverview?.hasTermsOfServiceLink !== 'N/A'"
            [lock]='isFreemium && !isFollowing' label='Terms and Conditions Detected'>

            <ng-container #value>
              <ng-container *ngIf="_userService.ottDiscoveryEnabled()">
                <a class="btn btn-link p-0"
                  (click)="goToDiscoveryClick({param: 'hasTermsAndConditionLink', paramValue: data?.riskOverview?.hasTermsOfServiceLink ? 'T' : 'F'})">
                  <img src="/assets/images/icon-indicator-{{data?.riskOverview?.hasTermsOfServiceLink | yesno}}-2.svg"
                    alt="Info Icon" />
                  {{data?.riskOverview?.hasTermsOfServiceLink | yesno:"capitalize"}}
                </a>
              </ng-container>
              <ng-container *ngIf=!_userService.ottDiscoveryEnabled()>
                {{data?.riskOverview?.hasTermsOfServiceLink | yesno:"capitalize"}}
              </ng-container>
            </ng-container>
          </info-list-item>

          <info-list-item *ngIf="data?.riskOverview?.hasPrivacyLink !== 'N/A'" [lock]='isFreemium && !isFollowing'
            label='Privacy Policy Detected'>

            <ng-container #value>
              <ng-container *ngIf="_userService.ottDiscoveryEnabled()">
                <a class="btn btn-link p-0"
                  (click)="goToDiscoveryClick({param: 'hasPrivacyLink', paramValue: data?.riskOverview?.hasPrivacyLink ? 'T' : 'F'})">
                  <img src="/assets/images/icon-indicator-{{data?.riskOverview?.hasPrivacyLink | yesno}}-2.svg"
                    alt="Info Icon" />
                  {{data?.riskOverview?.hasPrivacyLink | yesno:"capitalize"}}
                </a>
              </ng-container>
              <ng-container *ngIf="!_userService.ottDiscoveryEnabled()">
                {{data?.riskOverview?.hasPrivacyLink | yesno:"capitalize"}}
              </ng-container>
            </ng-container>
          </info-list-item>

          <info-list-item *ngIf="data?.riskOverview?.appAgeRisk !== 'N/A'" label='App Age Risk'>

            <risk-heat-meter #value
              (interact)='_userService.ottDiscoveryEnabled() ? goToDiscoveryClick({param: "appAgeRisk", paramValue: data?.riskOverview?.appAgeRisk}) : null'
              [risk]='data?.riskOverview?.appAgeRisk'></risk-heat-meter>
          </info-list-item>

          <info-list-item label='COPPA Violation Risk' [lock]='!_userService.ctvCoppaPermissionsRiskEnabled()'>

            <risk-heat-meter #value [risk]='data?.coppaPermissions?.coppaRisk'></risk-heat-meter>
          </info-list-item>
        </div>
      </div>
    </div>
  </div>
</div>